/* Alarie - eleccion de color.
   Al pulsar una pastilla se cambia SOLO el valor de la opcion de color y se
   busca la variante que encaja con el resto de opciones ya elegidas (el pack,
   por ejemplo). Si esa combinacion no existe, la pastilla sale deshabilitada.
   Mientras el producto no tenga opcion de color, este archivo no hace nada. */
(function () {
  'use strict';
  if (window.__alarieColor) return;
  window.__alarieColor = true;

  function read() {
    var s = document.querySelector('script[data-al-variants]');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }

  function init() {
    var box = document.querySelector('.al-col');
    var vars = read();
    if (!box || !vars || !vars.length) return;

    var pos = parseInt(box.getAttribute('data-col-opt'), 10) - 1;
    var input = document.getElementById('alVariantId');
    var price = document.querySelector('[data-add-price]');
    var btns = Array.prototype.slice.call(box.querySelectorAll('.al-col__b'));

    function current() {
      var id = input ? parseInt(input.value, 10) : 0;
      for (var i = 0; i < vars.length; i++) if (vars[i].id === id) return vars[i];
      return vars[0];
    }

    function find(color) {
      var c = current();
      for (var i = 0; i < vars.length; i++) {
        var v = vars[i], ok = true;
        for (var j = 0; j < v.o.length; j++) {
          var want = j === pos ? color : c.o[j];
          if (v.o[j] !== want) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    /* Marca la pastilla elegida y tacha las combinaciones que no existen. */
    function paint() {
      var c = current();
      btns.forEach(function (b) {
        var col = b.getAttribute('data-col');
        b.setAttribute('aria-current', c.o[pos] === col ? 'true' : 'false');
        var v = find(col);
        if (v && v.a) b.removeAttribute('disabled');
        else b.setAttribute('disabled', '');
      });
    }

    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var v = find(b.getAttribute('data-col'));
        if (!v) return;
        if (input) input.value = v.id;
        if (price && !price.dataset.lockedByPack) price.textContent = v.pm;
        paint();
        document.dispatchEvent(new CustomEvent('alarie:variant', { detail: v }));
      });
    });

    /* Si el pack cambia la variante, repintamos para que el color siga bien. */
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.al-pdPack')) setTimeout(paint, 0);
    });

    paint();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
